import React, { useRef, useState } from "react";
import "./home.scss";
import { Button, Row, Col, Carousel } from "antd";
import {
  BitCoin,
  BusinessSteeringImage,
  CheckIcon,
  HandShake,
  MobileImage,
  MoneyIcon,
  PaymentGatewayIcon,
  PaymentImage,
  PaymentLinkIcon,
  PayoutsIcon,
  Pig,
  ProfileImage,
  SalyGirl,
  SmartDashboardIcon,
  ThunderIcon,
  TopBanner,
} from "../../img";
import StarRating from "../star-rating";
import Footer from "../../footer/footer";
import HeaderComp from "../../header/header-comp";
import DemoForm from "../demo-form/demo-form";

const paymentSteps = [
  {
    heading: "Signup & activation",
    lineOne: "Register and get your",
    lineTwo: "account activation in no",
    lineThree: "time",
    icon: "../../img/pig.png",
  },
  {
    heading: "Accept Payment",
    lineOne: "Start accepting payments.",
    lineTwo: "We support all major",
    lineThree: "payment methods.",
    icon: "../../img/key.png",
  },
  {
    heading: "Customize",
    lineOne: "Perfect solution for the",
    lineTwo: "colors & theme of your",
    lineThree: "business identity",
    icon: "../../img/snap.png",
  },
];

const businessPoints = [
  "Allow your customers to pay you easily using their preferred online payment method from 120+ available options.",
  "Your Indian customers will pay you with cards, net banking, UPI, mobile wallets, single QR code, or EMI.",
  "Accept global payments now!",
];

const providerCards = [
  {
    icon: PaymentGatewayIcon,
    heading: "Payment Gateway",
    lineOne: "Receive your payments securely on your.",
    lineTwo: "website or app.",
  },
  {
    icon: PayoutsIcon,
    heading: "Payouts",
    lineOne: "Send payments instantly and securely to the",
    lineTwo: "bank accounts.",
  },
  {
    icon: SmartDashboardIcon,
    heading: "Smart Dashboard",
    lineOne: "Get real-time records of your transactions",
    lineTwo: "and settlements.",
  },
  {
    icon: PaymentLinkIcon,
    heading: "Payment Link",
    lineOne: "Easily send payment links and accept easy",
    lineTwo: "payments.",
  },
];

const customerReview = [
  {
    name: "Rashmi Mehta",
    image: ProfileImage,
    position: "CEO at Meta",
    review: `" I particularly love the recurring payment feature, as it saves me time and effort in managing subscription- based services. Additionally, the integration with my e-commerce platform was a breeze. Kudos to the team for creating such a fantastic product! "`,
  },
  {
    name: "Mark Jukerberg",
    image: ProfileImage,
    position: "Designer",
    review: `"I paid off $24,000 first year"I particularly love the recurring payment feature, as it saves me time and effort in managing subscription- based services. Additionally, the integration with my e-commerce platform was a breeze. Kudos to the team for creating such a fantastic product!"`,
  },
  {
    name: "Rashmi Mehta",
    image: ProfileImage,
    position: "CEO at Meta",
    review: `" I particularly love the recurring payment feature, as it saves me time and effort in managing subscription- based services. Additionally, the integration with my e-commerce platform was a breeze. Kudos to the team for creating such a fantastic product! "`,
  },
  {
    name: "Mark Jukerberg",
    image: ProfileImage,
    position: "Designer",
    review: `"I paid off $24,000 first year"I particularly love the recurring payment feature, as it saves me time and effort in managing subscription- based services. Additionally, the integration with my e-commerce platform was a breeze. Kudos to the team for creating such a fantastic product!"`,
  },
  {
    name: "Rashmi Mehta",
    image: ProfileImage,
    position: "CEO at Meta",
    review: `" I particularly love the recurring payment feature, as it saves me time and effort in managing subscription- based services. Additionally, the integration with my e-commerce platform was a breeze. Kudos to the team for creating such a fantastic product! "`,
  },
  {
    name: "Mark Jukerberg",
    image: ProfileImage,
    position: "Designer",
    review: `"I paid off $24,000 first year"I particularly love the recurring payment feature, as it saves me time and effort in managing subscription- based services. Additionally, the integration with my e-commerce platform was a breeze. Kudos to the team for creating such a fantastic product!"`,
  },
];

const managePayments = [
  {
    point: "Easy to collect",
    subPoint:
      "An API solution enabled with SMS/Email feature to push customized content with auto-generated payment links over your own billing cycle.",
  },
  {
    point: "Smart & Secure",
    subPoint:
      "We have secure servers which makes our online transactions compliant with bank-level security using 128 bit SSL encryption.",
  },
  {
    point: "24x7 Support",
    subPoint:
      "Need help at any stage? Reach our support team via emails, calls, or chats. We are always happy to assist !",
  },
];

const itemsPerView = 2;
const chunkArray = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, index) =>
    arr.slice(index * size, index * size + size)
  );
};

const Home = () => {
  const aboutRef = useRef();
  const serviceRef = useRef();
  const reviewRef = useRef();
  const contactRef = useRef();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const scrollToTab = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        if (aboutRef.current) {
          aboutRef.current.scrollIntoView({ behavior: "smooth" });
        }
        break;
      case 1:
        if (serviceRef.current) {
          serviceRef.current.scrollIntoView({ behavior: "smooth" });
        }
        break;
      case 2:
        if (reviewRef.current) {
          reviewRef.current.scrollIntoView({ behavior: "smooth" });
        }
        break;
      case 3:
        if (contactRef.current) {
          setIsModalVisible(true)
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="home-container">
      <Row xs={{ span: 24 }} className="top-banner">
        <HeaderComp scrollTab={scrollToTab} />
        <Row style={{ paddingTop: "50px" }}>
          <Col
            sm={{ span: 15 }}
            xs={{ span: 15 }}
            md={{ span: 9 }}
            className="left-contents"
          >
            <div className="white-text">Start Accepting payments with</div>
            <div className="blue-text">PayzEasy</div>
            <div className="small-text">
              Receive online payments safely securely on your website or mobile
              app
            </div>
            <Button
              onClick={() => setIsModalVisible(true)}
              style={{ background: "#48B7EF" }}
            >
              Book a Demo
            </Button>
          </Col>
          <Col
            md={15}
            xl={15}
            xxl={15}
            sm={24}
            xs={24}
            className="right-contents"
          >
            <img className="banner-iamge" src={TopBanner} />
          </Col>
        </Row>
      </Row>
      <div ref={aboutRef} className="steps-section">
        <div className="blue-heading">EASY STEPS</div>
        <div
          style={{ lineHeight: "60px", paddingTop: "30px" }}
          className="section-heading"
        >
          Easy steps to Get Started
        </div>
        <Row align={"center"} style={{ margin: 0 }} span={23} gutter={[25, 25]}>
          {paymentSteps.map((element, index) => (
            <Col
              className="steps-box"
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 6 }}
              xl={{ span: 6 }}
              xxl={{ span: 6 }}
            >
              <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                width="90%"
                height="245"
                viewBox="0 0 369 245"
                fill="none"
              >
                <rect x="10%" y="10%" width="80%" height="80%">
                  <img src={Pig} />
                </rect>
                <path
                  d="M0.463836 9.27674C0.463836 4.40951 4.4095 0.463836 9.27673 0.463836H271.267C273.574 0.463836 275.788 1.36819 277.436 2.98276L365.178 88.9791C366.869 90.6366 367.822 92.905 367.822 95.2731V235.629C367.822 240.496 363.877 244.442 359.009 244.442H9.27673C4.40951 244.442 0.463836 240.496 0.463836 235.629V9.27674Z"
                  fill="#F8F8F8"
                  stroke="#48B7EF"
                  stroke-width="0.927673"
                />
                <rect x="10%" y="10%" width="80%" height="80%">
                  <animateMotion repeatCount="indefinite" dur="4s">
                    <mpath href={Pig} />
                    <rect x="0" y="0" width="40" height="40" />
                  </animateMotion>
                </rect>
                <text
                  x="40"
                  y="20%"
                  fill="#48B7EF"
                  fontFamily="Clash Display Medium"
                  fontWeight={"bold"}
                  fontSize={"24px"}
                  dominant-baseline="middle"
                  text-anchor="start"
                >
                  {element.heading}
                </text>
                <text
                  x="40"
                  y="40%"
                  fontFamily="Clash Display Medium"
                  dominant-baseline="start"
                  text-anchor="start"
                  fontSize={"19px"}
                  line-height="61.226px"
                  fill="#333"
                >
                  <tspan x="43" dy="0">
                    {element.lineOne}
                  </tspan>
                  <tspan x="43" dy="1.2em">
                    {element.lineTwo}
                  </tspan>
                  <tspan x="43" dy="1.2em">
                    {element.lineThree}
                  </tspan>
                </text>
              </svg>
            </Col>
          ))}
        </Row>
      </div>
      <div className="payment-section">
        <div className="blue-heading">Easily PAYMENT</div>
        <div className="section-heading">Accept payments & send payouts</div>
        <div className="bottom-section">
          <div className="left-section">
            <img src={PaymentImage} />
          </div>
          <Row className="right-section">
            <Col className="payment-info">
              Our esteemed clientele in the payment gateway industry has
              discovered the unparalleled benefits of utilizing our exceptional
              content writing service.By availing our expertise, businesses
              today can effortlessly enhance their ability to accept payments
              and seamlessly process payouts.
            </Col>
            <Col span={24} className="color-texts">
              <div className="color-bold">
                <div className="bold-text">250+</div>
                <div className="bold-text">Happy Clients</div>
              </div>
              <div className="color-bold">
                <div style={{ color: "#48b7ef" }} className="bold-text">
                  99%
                </div>
                <div style={{ color: "#48b7ef" }} className="bold-text">
                  Customer Satisfaction
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Row
        style={{ background: "#000", justifyContent: "space-between" }}
        className="business-section"
      >
        <Col
          sm={{ span: 24 }}
          xs={{ span: 24 }}
          md={{ span: 10 }}
          xl={{ span: 10 }}
          xxl={{ span: 10 }}
          className="left-section"
        >
          <div className="blue-text-provide">BUSINESS STEERING</div>
          <div className="large-heading">
            Simple interface <br />
            for business steering
          </div>
          <div className="points-section">
            <div className="points">
              {businessPoints.map((element, index) => (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "flex-start",
                    paddingBottom: "15px",
                  }}
                  key={index}
                >
                  <img
                    style={{ paddingTop: "5px", width: "23px" }}
                    src={CheckIcon}
                  />
                  <div className="point-text" key={index}>
                    {element}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Button
            style={{
              background: "#48b7ef",
              color: "#fff",
              border: "unset",
              color: "#000",
              fontWeight: "600",
              marginTop: "20px",
              borderRadius: "10px",
              height: "39px",
              width: "130px",
            }}
          >
            Get Started
          </Button>
        </Col>
        <Col
          sm={{ span: 24 }}
          xs={{ span: 24 }}
          md={{ span: 10 }}
          xl={{ span: 10 }}
          xxl={{ span: 10 }}
          className="right-section"
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src={BusinessSteeringImage}
          />
        </Col>
      </Row>
      <div ref={serviceRef} className="provide-section">
        <div className="blue-text-provide">PROVIDE</div>
        <div style={{ color: "#000" }} className="large-heading">
          What We Provide?
        </div>
        <div className="small-info">
          10,000+ businesses today uses our service to accept payments & send
          payouts
        </div>
        <Row
          className="what-we-provides"
          span={24}
          style={{
            marginTop: "60px",
            justifyContent: "space-between",
            marginLeft: "16px",
          }}
        >
          <Col
            style={{ width: "100%" }}
            sm={24}
            md={24}
            lg={10}
            xl={11}
            className="left-section"
          >
            <img src={SalyGirl} />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              style={{ marginLeft: "13px" }}
              viewBox="0 0 519 736"
              fill="none"
            >
              <path
                d="M0.351562 0.64209L417.852 10.321L514.229 80.3262C516.819 82.2076 518.352 85.2156 518.352 88.417V725.642C518.352 731.165 513.874 735.642 508.352 735.642H10.3515C4.8287 735.642 0.351562 731.165 0.351562 725.642V0.64209Z"
                fill="#101010"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              style={{
                position: "absolute",
                zIndex: 9,
                top: "-33px",
                left: "-13px",
              }}
              viewBox="0 0 533 750"
              fill="none"
            >
              <path
                d="M0.351562 9.99999C0.351562 4.47714 4.82872 0 10.3516 0H395.032C397.187 0 399.285 0.696487 401.012 1.98567L528.332 97.0006C530.862 98.8882 532.352 101.859 532.352 105.015V740C532.352 745.523 527.874 750 522.352 750H10.3516C4.82871 750 0.351562 745.523 0.351562 740V9.99999Z"
                fill="#48B7EF"
                z-index={9999}
              />
            </svg>
          </Col>
          <Row className="provider-right-section">
            <Col span={24} className="right-section">
              {providerCards.map((element, index) => (
                <Col
                  span={24}
                  style={{ width: "100%" }}
                  key={index}
                  className="info-cards"
                >
                  <img className="card-icon" src={element.icon} />
                  <div className="card-heading">{element.heading}</div>
                  <div className="card-content">{element.lineOne}</div>
                  <div style={{ lineHeight: 0 }} className="card-content">
                    {element.lineTwo}
                  </div>
                </Col>
              ))}
            </Col>
          </Row>
        </Row>
      </div>
      <Row className="payment-manage">
        <Row
          className="business-section"
          style={{ paddingRight: "10px", width: "51%" }}
        >
          <Col span={23} className="left-section">
            <div className="blue-text-provide">MANAGE PAYMENTS</div>
            <div style={{ color: "#fff" }} className="large-heading">
              Ways to Manage Your Payments
            </div>
            <div className="small-info">
              PayzEasy is a simple payment gateway service that allows you to
              run your business easily.
            </div>
            <div className="points-section">
              <div className="points">
                {managePayments.map((element, index) => (
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "flex-start",
                      paddingBottom: "15px",
                    }}
                    key={index}
                  >
                    <img
                      style={{ paddingTop: "5px", width: "23px" }}
                      src={CheckIcon}
                    />
                    <div className="point-text" key={index}>
                      <div className="point-bold">{element?.point} : </div>
                      {element.subPoint}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Button
              style={{
                background: "#48b7ef",
                color: "#fff",
                border: "unset",
                color: "#000",
                fontWeight: "600",
                marginTop: "20px",
                borderRadius: "10px",
                height: "39px",
                width: "130px",
              }}
            >
              Get Started
            </Button>
          </Col>
        </Row>
        <Row style={{ width: "49%" }}>
          <Col className="blue-section" span={24}>
            <img src={HandShake} />
          </Col>
        </Row>
      </Row>
      <div ref={reviewRef} className="reviews-section">
        <div className="blue-heading">PROVIDE</div>
        <div
          style={{ lineHeight: "60px", padding: "0 20%" }}
          className="section-heading"
        >
          We Have Great User Experiences
        </div>
        <div className="chanting-container">
          <Carousel arrows>
            {chunkArray(customerReview, itemsPerView).map(
              (carouselItem, index) => (
                <div
                  style={{ width: "100%" }}
                  className="countries-list carousel-list"
                  key={index}
                >
                  {carouselItem.map((jobs, itemIndex) => (
                    <div key={itemIndex} className="carousel-card">
                      <div className="reviews">{jobs.review}</div>
                      <div className="name-and-rating">
                        <div className="top-carousel-container">
                          <img src={jobs.image} />
                          <div className="name-and-position">
                            <div className="name">{jobs.name}</div>
                            <div className="position">{jobs.position}</div>
                          </div>
                        </div>
                        <StarRating rating={7} />
                      </div>
                    </div>
                  ))}
                </div>
              )
            )}
          </Carousel>
        </div>
      </div>
      <div className="ads-section">
        <div className="inner-section">
          <div className="icons-and-headings">
            <img
              className="lightning-image"
              alt="lightning-fast-payment"
              src={ThunderIcon}
            />
            <div className="heading-container">
              <div className="large-heading">Easy & Advanced Integration</div>
              <div className="small-heading">
                Go live with in some minutes with our simple SDKs & APIs for all
                available platforms
              </div>
            </div>
            <img alt="money" className="money-image" src={MoneyIcon} />
          </div>
          <div className="technical-points">
            <div className="point">ROBUST APIS</div>
            <div className="point">PLUGINS & SDKS</div>
            <div className="point">24X7 SUPPORT</div>
            <div className="point">TECHNICAL HELP</div>
          </div>
          <div className="bottom-images">
            <img className="bitcoin-image" alt="bitcoin" src={BitCoin} />
            <img className="mobile-image" alt="mobile-app" src={MobileImage} />
          </div>
        </div>
      </div>
      <Footer contactRef={contactRef} scrollTab={scrollToTab} />
      {isModalVisible && (
        <DemoForm visible={isModalVisible} onCancel={handleCancel} />
      )}
    </div>
  );
};

export default Home;
